import { JT } from "../../../components/ui/jumbotronTokens";

// #945 follow-up. Single job: render a small display-only badge for a
// server-computed per-leg market-support warningCode in the post-save
// acknowledgment. No business logic — it only maps a code to a label + tone.
// Unknown/missing codes render nothing (fail-quiet).
const WARNING_BADGES = {
  // Known market, no settlement handler yet — we save it, user tracks manually.
  UNSUPPORTED_MARKET_AUTO_GRADE: { label: "Can't auto-grade", tone: JT.status.missing },
  // Market term not recognized at all.
  UNKNOWN_MARKET: { label: "Unrecognized", tone: JT.status.live },
};

export default function LegWarningBadge({ warningCode }) {
  // Own-property lookup only: a bare WARNING_BADGES[warningCode] would return a
  // truthy INHERITED value for keys like "__proto__"/"constructor"/"toString",
  // slip past a naive guard, and throw on destructure. hasOwnProperty keeps the
  // "unknown/missing codes render nothing" contract true for every string.
  const badge =
    warningCode && Object.prototype.hasOwnProperty.call(WARNING_BADGES, warningCode)
      ? WARNING_BADGES[warningCode]
      : null;
  if (!badge) return null;
  const { label, tone } = badge;
  return (
    <span
      style={{
        display: "inline-block",
        fontSize: 9,
        fontWeight: 800,
        letterSpacing: "0.5px",
        textTransform: "uppercase",
        color: tone.color,
        background: tone.dim,
        border: `1px solid ${tone.border}`,
        borderRadius: 999,
        padding: "1px 6px",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
}
